import { render, staticRenderFns } from "./Content.vue?vue&type=template&id=247020a0&scoped=true"
var script = {}
import style0 from "./Content.vue?vue&type=style&index=0&id=247020a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "247020a0",
  null
  
)

export default component.exports